// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as V3RevealApi$LiteracyplanetTupperware from "./V3RevealApi.res.mjs";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V3ClozeDndStyleContext$LiteracyplanetTupperware from "./V3ClozeDndStyleContext.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

function findByIdPairRightSide(answerStringArray, responseOptionId) {
  return Belt_List.reduce(answerStringArray, undefined, (function (acc, answer) {
                if (acc !== undefined) {
                  return acc;
                }
                var match = answer.split(Reducer$LiteracyplanetTupperware.splitChar);
                if (match.length !== 2) {
                  return acc;
                }
                var left = match[0];
                var right = match[1];
                if (left === responseOptionId) {
                  return right;
                } else {
                  return acc;
                }
              }));
}

function V3ClozeBucketProvider(props) {
  var questionIndex = props.questionIndex;
  var match = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match[1];
  var match$1 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var getStep = match$1.getStep;
  var dndStyle = V3ClozeDndStyleContext$LiteracyplanetTupperware.use();
  var answerVisible = match$1.isCorrectAnswerVisible(questionIndex);
  var getMarkType = function (id) {
    return Reducer$LiteracyplanetTupperware.getMarkTypeWip(getStep(questionIndex), id);
  };
  var findDroppedId = function (id) {
    if (dndStyle === "Bucket") {
      return Belt_Option.flatMap(Reducer$LiteracyplanetTupperware.mapIdPair(getStep(questionIndex), (function (dragId, param) {
                        return dragId === id;
                      })), (function (param) {
                    return param[1];
                  }));
    } else {
      return Belt_Option.flatMap(Reducer$LiteracyplanetTupperware.mapIdPairWithGroup(getStep(questionIndex), (function (dragId, param, param$1) {
                        return dragId === id;
                      })), (function (param) {
                    return param[2];
                  }));
    }
  };
  var isDropped = function (id) {
    if (dndStyle === "Bucket") {
      return Belt_Option.isSome(Reducer$LiteracyplanetTupperware.mapIdPair(getStep(questionIndex), (function (param, dropId) {
                        return dropId === id;
                      })));
    } else {
      return Belt_Option.isSome(Reducer$LiteracyplanetTupperware.mapIdPairWithGroup(getStep(questionIndex), (function (param, param$1, group) {
                        return group === id;
                      })));
    }
  };
  var findCorrectResponse = function (id, index) {
    var match = getStep(questionIndex);
    if (typeof match !== "object") {
      return ;
    }
    if (match.TAG === "Attempted") {
      return ;
    }
    var match$1 = match._0;
    if (typeof match$1 !== "object") {
      return ;
    }
    var answer = match$1._0.answer;
    if (dndStyle === "Bucket") {
      return findByIdPairRightSide(answer, id);
    } else {
      return Belt_Option.map(findByIdPairRightSide(answer, id), (function (group) {
                    return V3DndBehaviour$LiteracyplanetTupperware.makeUniqueIdFromIndex(String(index), group);
                  }));
    }
  };
  var onUndoDrop = function (drag, drop) {
    if (Reducer$LiteracyplanetTupperware.isMarked(getStep(questionIndex))) {
      return ;
    }
    if (dndStyle === "Bucket") {
      return dispatch({
                  TAG: "DeleteResponseIdentifier",
                  _0: questionIndex,
                  _1: {
                    TAG: "IdPair",
                    _0: drag,
                    _1: drop
                  }
                });
    }
    var match = drop.split(V3DndBehaviour$LiteracyplanetTupperware.groupSplitChar);
    if (match.length !== 2) {
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "V3ClozeBucketProvider.res",
              84,
              16
            ],
            Error: new Error()
          };
    }
    var drop$1 = match[1];
    dispatch({
          TAG: "DeleteResponseIdentifier",
          _0: questionIndex,
          _1: {
            TAG: "Group",
            _0: drop,
            _1: {
              TAG: "IdPair",
              _0: drag,
              _1: drop$1
            }
          }
        });
  };
  var onDrop = function (drag, drop, group) {
    if (Reducer$LiteracyplanetTupperware.isMarked(getStep(questionIndex))) {
      return ;
    } else {
      return dispatch({
                  TAG: "SetQuestionState",
                  _0: questionIndex,
                  _1: group !== undefined ? ({
                        TAG: "ToggleResponse",
                        _0: {
                          TAG: "BoolResponsePayload",
                          _0: {
                            TAG: "Group",
                            _0: group,
                            _1: {
                              TAG: "IdPair",
                              _0: drag,
                              _1: drop
                            }
                          }
                        }
                      }) : ({
                        TAG: "SetResponse",
                        _0: {
                          TAG: "BoolResponsePayload",
                          _0: {
                            TAG: "IdPair",
                            _0: drag,
                            _1: drop
                          }
                        }
                      }),
                  _2: "ResponseMarking"
                });
    }
  };
  var tmp;
  tmp = dndStyle === "Bucket" ? "pilotBucket" : "pilotChain";
  return React.createElement("div", {
              className: tmp
            }, React.createElement(V3RevealApi$LiteracyplanetTupperware.Provider.make, {
                  value: {
                    reveal: props.reveal
                  },
                  children: React.createElement(V3DndBehaviour$LiteracyplanetTupperware.DndProvider.make, {
                        api: {
                          findDroppedId: findDroppedId,
                          isDropped: isDropped,
                          findCorrectResponse: findCorrectResponse,
                          answerVisible: answerVisible,
                          getMarkType: getMarkType,
                          onUndoDrop: onUndoDrop,
                          onDrop: onDrop,
                          overClassName: props.overClassName,
                          dropClassName: props.dropClassName,
                          renderDragComponent: props.renderDragComponent,
                          renderDragOverlayComponent: props.renderDragOverlayComponent,
                          renderAlreadyDraggedPlaceholder: props.renderAlreadyDraggedPlaceholder,
                          renderAlreadyDraggedAndMarkedPlaceholder: props.renderAlreadyDraggedAndMarkedPlaceholder,
                          renderDroppedComponent: props.renderDroppedComponent,
                          renderCorrectDroppedComponent: props.renderCorrectDroppedComponent,
                          renderIncorrectDroppedComponent: props.renderIncorrectDroppedComponent,
                          renderUndroppedMarkedComponent: props.renderUndroppedMarkedComponent
                        },
                        children: props.children
                      })
                }));
}

var make = V3ClozeBucketProvider;

export {
  findByIdPairRightSide ,
  make ,
}
/* react Not a pure module */
